import _toConsumableArray from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
// Copyright 2017-2021 @polkadot/types authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { assert, compactToU8a, isU8a, u8aConcat } from '@polkadot/util';
import { AbstractArray } from "./AbstractArray.mjs";
import { typeToConstructor } from "./utils/index.mjs";
import { Vec } from "./Vec.mjs";
/**
 * @name VecFixed
 * @description
 * This manages codec arrays of a fixed length
 */

export var VecFixed =
/*#__PURE__*/
function (_AbstractArray) {
  _inherits(VecFixed, _AbstractArray);

  function VecFixed(registry, Type, length) {
    var _getPrototypeOf2;

    var _this;

    var value = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

    _classCallCheck(this, VecFixed);

    var Clazz = typeToConstructor(registry, Type);
    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(VecFixed)).call.apply(_getPrototypeOf2, [this, registry].concat(_toConsumableArray(VecFixed.decodeVecFixed(registry, Clazz, length, value)))));
    _this._Type = void 0;
    _this._Type = Clazz;
    return _this;
  }
  /** @internal */


  _createClass(VecFixed, [{
    key: "toU8a",
    value: function toU8a() {
      // we override, we don't add the length prefix for ourselves, and at the same time we
      // ignore isBare on entries, since they should be properly encoded at all times
      var encoded = this.map(function (entry) {
        return entry.toU8a();
      });
      return encoded.length ? u8aConcat.apply(void 0, _toConsumableArray(encoded)) : new Uint8Array([]);
    }
    /**
     * @description Returns the base runtime type name for this instance
     */

  }, {
    key: "toRawType",
    value: function toRawType() {
      return "[".concat(this.Type, ";").concat(this.length, "]");
    }
  }, {
    key: "Type",

    /**
     * @description The type for the items
     */
    get: function get() {
      return new this._Type(this.registry).toRawType();
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */

  }, {
    key: "encodedLength",
    get: function get() {
      return this.toU8a().length;
    }
  }], [{
    key: "decodeVecFixed",
    value: function decodeVecFixed(registry, Type, allocLength, value) {
      var values = Vec.decodeVec(registry, Type, isU8a(value) ? u8aConcat(compactToU8a(allocLength), value) : value);

      while (values.length < allocLength) {
        values.push(new Type(registry));
      }

      assert(values.length === allocLength, "Expected a length of exactly ".concat(allocLength, " entries"));
      return values;
    }
  }, {
    key: "with",
    value: function _with(Type, length) {
      return (
        /*#__PURE__*/
        function (_VecFixed) {
          _inherits(_class, _VecFixed);

          function _class(registry, value) {
            _classCallCheck(this, _class);

            return _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, registry, Type, length, value));
          }

          return _class;
        }(VecFixed)
      );
    }
  }]);

  return VecFixed;
}(AbstractArray);